module.exports = __webpack_public_path__ + "static/media/skill6.1d0ee04c.jpeg";